module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('div', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "wysiwyg"
  }, [_c('h1', [_vm._v("Personal access token")]), _vm._v(" "), _c('h4', [_vm._v("Make sure to copy your new personal access token now. You won’t be able to see it again!")]), _vm._v(" "), _c('h4', [_vm._v("If you forgot your personal access token, revoke it and generate again!")]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "control is-fullwidth"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.token),
      expression: "token"
    }],
    staticClass: "input",
    attrs: {
      "rows": "4",
      "id": "token",
      "type": "text",
      "placeholder": "Checking your personal token",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.token = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_c('div', {
    staticClass: "control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "control is-fullwidth"
  }, [(_vm.checkStatus() === 99) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.clipboard()
      }
    }
  }, [_vm._v("Copy to Clipboard")]) : _vm._e(), _vm._v(" "), (_vm.checkStatus() === 0) ? _c('button', {
    staticClass: "button is-normal",
    on: {
      "click": function($event) {
        _vm.generatepersonaltoken()
      }
    }
  }, [_vm._v("Generate")]) : _vm._e(), _vm._v(" "), (_vm.checkStatus() === 1) ? _c('button', {
    staticClass: "button is-danger",
    on: {
      "click": function($event) {
        _vm.revokepersonaltoken()
      }
    }
  }, [_vm._v("Revoke")]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Personal access token")])])
}]}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fce624d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"_CLIENT_ID_PLACE_HOLDER_","replace":"lfms21abk334e3i1lnkpr70ep"},{"search":"_BASE_API_PLACE_HOLDER_","replace":"https:/homeiottf-dev.auth.ap-northeast-2.amazoncognito.com"},{"search":"_CALLBACK_URL_HOLDER_","replace":"https:/www.homeiottf.com"}]}!./client/views/auth/Personal-Token.vue